import { RtButton } from '@dpa/react-buttons';
import { Link } from '@/i18n/navigation';
import { SyntheticEvent } from 'react';

type TProps = {
  leadingSlot?: React.ReactNode;
  href: string;
  label: string;
};
export const FooterButton = ({ label, href, leadingSlot }: TProps) => {
  const handleStopPropagation = (event: SyntheticEvent<HTMLElement>) => {
    event.stopPropagation();
  };

  return (
    <Link
      href={href}
      onClick={handleStopPropagation}
      target="_blank"
      rel="noopener noreferrer"
    >
      <RtButton
        label={label}
        modifier="base"
        size="sm"
        type="button"
        use="foggy"
        leadingSlot={leadingSlot}
        width="fill"
      />
    </Link>
  );
};
